import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-col">
          <img src="/images/logo.png" alt="Logo" className="footer-logo" />
          <p className="footer-text">
            Tranquility Distributors is a leading LPG distribution company in
            Zambia, proudly partnering with AFROX to provide safe, reliable, and
            efficient LPG solutions.
          </p>
        </div>
        <div className="footer-col">
          <h3>Contact Us</h3>
          <p>
            <span className="icon-pin"></span> Head Office, Showgrounds, Lusaka
          </p>
          <p>
            <span className="icon-phone"></span> +260 97 7815724
          </p>
          <p>
            <span className="icon-mail"></span> info@tranquilitydis.com
          </p>
        </div>
        <div className="footer-col">
          <h3>Explore</h3>
          <ul className="footer-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/shop">Shop</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>
            © {new Date().getFullYear()} Tranquility Distributors. All rights
            reserved.
          </p>

          <p>
            Developed by{" "}
            <a href="https://kafuetechnologies.com/" target="_blank">
              Kafue Technologies
            </a>{" "}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
